import './App.css';
import Header from './components/Header/Header';
import {BrowserRouter as Router, Route,Routes} from 'react-router-dom'
import Footer from './components/Footer/Footer';
import Home from './Pages/Home/Home'
import axios from "axios";
import React from 'react';
import Quiz from './Pages/Quiz/Quiz';
import Result from './Pages/Result/Result';
import {useState} from 'react';
function App() {
  const [questions, setQuestions] = useState();
  const [name, setName] = useState("");
  const [score,setScore]=useState(0);
  const fetchQuestion=async(category = "", difficulty = "")=>{
      const {data}=await axios.get(`https://opentdb.com/api.php?amount=10${category &&`&category=${category}`}${difficulty &&`&difficulty=${difficulty}`}&type=multiple`);
      setQuestions(data.results);
    };
  
  return (
    <Router>
    <div className="app" style={{backgroundImage:"url(./ques1.png)"}}>
       <Header/>
       <Routes> 
         <Route path='/' element={<Home name={name} setName={setName} fetchQuestion={fetchQuestion}/>}/>
         <Route path='/quiz' element={<Quiz name={name} questions={questions} score={score} setScore={setScore} setQuestions={setQuestions}/>}/>
         <Route path='/result' element={<Result name={name} score={score}/>}/>
       </Routes>
       <br/>
       <br/>
       <br/>
       
       <Footer/>
    </div>
    </Router>
  );
}

export default App;
